import { dlTrackEvent } from 'components/dataLayer/dataLayer'
import React from 'react'

interface ICheckIcon {
  color?: string
  className?: string
  height?: number
  width?: number
}

const CheckIcon = ({ width = 18, height = 12, className = '', color }: ICheckIcon) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 18 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
  >
    <path d="M1 4.89912L7.10588 11.005L17.4859 0.625" stroke={color ?? 'currentColor'} strokeWidth="1.2" />
  </svg>
)

interface StepProps {
  title: string
  description?: React.ReactNode
  completed: boolean
  isLast?: boolean
  nextStepCompleted?: boolean
  position?: number
}

type Address = {
  neighborhood: string | null
  postalCode: string | null
  city: string | null
  state: string | null
  country: string | null
  streetType: string | null
  curp: string | null
  phone: string | null
  firstName: string | null
  lastName: string | null
  street1: string | null
  street2: string | null
  streetNumber: string | null
  apartament: string | null
  shippingDetails: string | null
}

type TStep = {
  step: number
  stepTitle: string
  checked: boolean
  addressTitle: string | null
  address: Address | null
}

const Step = ({ title, description, completed, isLast, nextStepCompleted, position }: StepProps) => (
  <div className="step">
    <div className="step__lines">
      <div className={`step__circle ${completed ? 'step__circle__complete' : 'step__circle__incomplete'}`}>
        {completed && <CheckIcon className="step__circle__icon" />}
      </div>
      {!isLast && (
        <div
          className={`step__lines__item ${nextStepCompleted ? 'step__lines__complete' : 'step__lines__incomplete'}`}
        />
      )}
    </div>
    <div className="pb-8">
      <h3 className={`step__title ${completed ? 'step__title__complete' : 'step__title__incomplete'}`}>{title}</h3>
      {
        <div className={`step__description ${position === 1 && 'invisible'}`}>
          {description ?? <div style={{ height: '22px' }}></div>}
        </div>
      }
    </div>
  </div>
)
interface IVerticalStepper {
  trackingDetail: TStep[]
  courier: any
}

const formatSteps = (
  trackingDetail: TStep[],
  courier: any
): { title: string; description?: JSX.Element; completed: boolean }[] => {
  console.log('courier', courier)
  if (!trackingDetail) {
    return null
  }

  const courierExists = () => {
    const url = courier?.url?.replace('{trackingNumber}', courier?.trackingNumber)

    if (url) {
      dlTrackEvent('user_interaction', {
        action: 'click',
        element: 'ver courier',
        section: 'tracking :: prize'
      })
      window.open(url, '_blank')
    }
  }

  return trackingDetail.map((step) => {
    const formattedStep: { title: string; description?: JSX.Element; completed: boolean } = {
      title: step.stepTitle.toUpperCase(),
      completed: step.checked
    }

    if (step.address && step.addressTitle) {
      formattedStep.description = (
        <div>
          {courier && (
            <div className="my-3">
              <p className="font-bold">
                Tracking N°: <span className="font-normal">{courier?.trackingNumber ?? 'no encontrado'}</span>
              </p>
              <p className="font-bold">
                Nombre courier:{' '}
                <button onClick={courierExists} className="font-normal underline">
                  {courier?.name}
                </button>
              </p>
            </div>
          )}

          <div className="font-bold my-1">{step.addressTitle.toUpperCase()}</div>
          <p>
            {step.address.street1 && (
              <>
                {step.address.street1},<br />
              </>
            )}
            {step.address.neighborhood && (
              <>
                {step.address.neighborhood},<br />
              </>
            )}
            {step.address.city && (
              <>
                {step.address.city}
                <br />
              </>
            )}
            {step.address.state && <>{step.address.state}</>}
          </p>
        </div>
      )
    }

    return formattedStep
  })
}

export default function VerticalStepper({ trackingDetail, courier }: IVerticalStepper) {
  const steps = formatSteps(trackingDetail, courier)
  return (
    <div>
      {steps &&
        steps.map((step, index) => (
          <Step
            key={index}
            {...step}
            position={index + 1}
            isLast={index === steps.length - 1}
            nextStepCompleted={index < steps.length - 1 ? steps[index + 1].completed : false}
          />
        ))}
    </div>
  )
}
